// core libs
import React from 'react';
import Promise from 'promise';
import $ from 'jquery';

import LocationMap from './elements/LocationMap';

import Messenger from './../common/Messenger';
import PageLoading      from '../PageLoading';
let messenger = new Messenger();

// import styles
import '../App.css';
import './location.css';

var sources = require('../config.json');
var mapconfig = require('./elements/mapstyle.json');

window.markers = [];

class Location extends React.Component {
	constructor(props) {
		super(props);

		var d = new Date();
		this.location_url = sources.location + "?ts=" + d.getTime();
		this.reset_level = 15;
		//let mapCenter = { lat: -37.752948, lng: 144.675844 };
		let mapCenter = { lat: -37.73433556809579, lng: 144.62883326891478}; //change these value to alter your starting point for directions

		this.state = {
			mapCenter: mapCenter,
			masterList: [],
			renderList: [],
			markerGroups: [],
			markerIcons: [],
			renderedMarkers: [],
			markerPopupIsVisible: false,
			detailsBoxVisible: false,
			selectedMarker: undefined,
			selectCategory: undefined,
			mapConfig: {
				zoom: this.reset_level,
				center: mapCenter,
				disableDefaultUI: true,
				zoomControl: true,
				styles: mapconfig
			},
			display: {
				buttonText: "Aerial Map",
				aerialMap: "",
				googleMap: "active",
				downloadButtonText: "Download Location Map",
				downloadURL: undefined,
			},
			aerialimageUrl: undefined,
			locationdownloadUrl: undefined,
			aerialdownloadUrl: undefined,
			masterplanOverlay: {},
			markerIconConfig: {}
		};

		this.onDataLoaded = this.onDataLoaded.bind(this);
		this.storeState = this.storeState.bind(this);
		this.setMarkerPopupState = this.setMarkerPopupState.bind(this);
		this.selectRenderList = this.selectRenderList.bind(this);
		this.onCategoryChange = this.onCategoryChange.bind(this);
		this.onMarkerClicked = this.onMarkerClicked.bind(this);
		this.markerFactory = this.markerFactory.bind(this);
		this.getIconConfig = this.getIconConfig.bind(this);
		this.onMapAerialSwitch = this.onMapAerialSwitch.bind(this);
	}

	componentDidMount() {
		$.ajax({url:this.location_url,dataType:'json'}).done(this.onDataLoaded);
	}

	onDataLoaded(data) {
		console.log(data.map);
		this.storeState({
			masterList: data.markers,
			renderList: [],
			markerGroups: data.markerGroups,
			masterplanOverlay: data.map,
			markerIconConfig: data.markerIcons,
			aerialimageUrl: data.map.aerialimageUrl,
			display: {
				buttonText: "Aerial Map",
				aerialMap: "",
				googleMap: "active",
				downloadButtonText: "Download Location Map",
				downloadURL: data.map.downloadUrl,
			},
			locationdownloadUrl: data.map.downloadUrl,
			aerialdownloadUrl: data.map.aerialDownloadUrl
		});

	}

	storeState(updateObject) {
		let newState = Object.assign(this.state, updateObject);
		this.setState(newState);
	}

	selectRenderList() {
		let renderList = [];

		if(this.state.renderList.length > 0) {
			renderList = this.state.renderList;
		} else {
			renderList = [];
		}

		return renderList;
	}

	onRenderMarkers(markers, map) {
		let bounds = new window.google.maps.LatLngBounds();
		bounds.extend(this.state.mapCenter);

		let mapMarkers = markers.map((markerDetails) => {
			let markerObj;
			if(markerDetails.markerGroupId!==0) {
				markerObj = this.markerFactory(markerDetails, map, this.onMarkerClicked.call(this, markerDetails));
			} else {
				markerObj = this.markerFactory(markerDetails, map, null);
			}
			bounds.extend(markerObj.position);
			return markerObj;
		});

		if(mapMarkers.length > 0) {
			map.fitBounds(bounds);
		}

		this.storeState({
			renderedMarkers: mapMarkers
		});
	}

	markerFactory(markerDetails, mapReference, onClickHandler) {
		let markerObject = new window.google.maps.Marker({
			position: { lat: markerDetails.latitude, lng: markerDetails.longtitude },
			map: mapReference,
			icon: this.getIconConfig(markerDetails.image, markerDetails.markerGroupId)
		});

		markerObject.addListener('click', onClickHandler);
		markerObject.mTag = markerDetails.title;

		window.markers.push(markerObject);
		return markerObject;
	}

	getIconConfig(markericon,markergroup) {
		let marker = {};
		var markers = this.state.markerIconConfig;

		if (markericon) {

			let markerID = markers.reduce((accum, curr, index) => {
				if(curr.id === markergroup) {
					accum = index;
				}

				return accum;
			}, null);

			marker = {
				url: markericon,
				size: new window.google.maps.Size(markers[markerID].sx, markers[markerID].sy),
				origin: new window.google.maps.Point(markers[markerID].ox, markers[markerID].oy),
				anchor: new window.google.maps.Point(markers[markerID].ax, markers[markerID].ay),
				scaledSize: new window.google.maps.Size(markers[markerID].ssx, markers[markerID].ssy),
				zIndex: window.google.maps.Marker.MAX_ZINDEX
			};

		}
		return(marker);
	}

	onMarkerClicked(markerDetails) {
		return function () {
			Promise.all([
				requestAndRenderDirections(this.state.mapCenter, markerDetails, window.google.maps.TravelMode['DRIVING'], this.googleMap.directionService),
				requestAndRenderDirections(this.state.mapCenter, markerDetails, window.google.maps.TravelMode['BICYCLING'], this.googleMap.directionService)
			]).then(function (responses) {
				// console.log('promise response');
				if(this.googleMap.directionsDisplay) {
					// console.log('reset directionsDisplay');
					this.googleMap.directionsDisplay.setMap(null);

					// console.log('create new directionsrenderer');
					this.googleMap.directionsDisplay = new window.google.maps.DirectionsRenderer({
						suppressMarkers: true
					});

					// console.log('set map on directionsrenderer');
					this.googleMap.directionsDisplay.setMap(this.googleMap.mapReference);
				} else {
					// console.log('create new directionsdisplay in else');
					this.googleMap.directionsDisplay = new window.google.maps.DirectionsRenderer({
						suppressMarkers: true
					});

					// console.log('set map in else');
					this.googleMap.directionsDisplay.setMap(this.googleMap.mapReference);
				}

				// console.log('set directions');
				this.googleMap.directionsDisplay.setDirections(responses[0]);

				// console.log('create timeout');
				setTimeout(function () {
					// console.log('firing set timeout');
					let elem = document.getElementById('super-awesome-show-me');
					// console.log(elem);
					elem.classList.add('visible');

					messenger.publish('send-data-to-box', {
						markerObject: markerDetails,
						directionsResponse: responses
					});
				}, 250);

				// console.log('store state');
				this.storeState({
					markerPopupIsVisible: true,
					selectedMarker: {
						markerObject: markerDetails,
						directionsResponse: {
							carResponse: responses[0],
							bikeResponse: responses[1]
						}
					}
				});

			}.bind(this));
		}.bind(this);
	}

	onMarkerPopupClose() {
		if(this.googleMap) {
			this.googleMap.directionsDisplay.setMap(null);
		}

		let bounds = new window.google.maps.LatLngBounds();
		bounds.extend(this.state.mapCenter);
		this.state.renderedMarkers.forEach(function (marker) {
			bounds.extend(marker.position);
		});

		this.googleMap.mapReference.fitBounds(bounds);

		this.storeState({
			markerPopupIsVisible: false,
			selectedMarker: undefined
		});

		setTimeout(function () {
			let elem = document.getElementById('super-awesome-show-me');
			elem.classList.remove('visible');
		}, 250);
	}

	setMarkerPopupState(markerVisibilityState) {
		return function () {
			this.storeState({
				markerPopupIsVisible: markerVisibilityState
			});
		}.bind(this);
	}

	onCategoryReset(selectedCategory) {
		//close the popup
		this.onMarkerPopupClose();

		//calling setMap(null) on markers removes them
		for(let j = 0; j < window.markers.length; j++) {
			window.markers[j].setMap(null);
		}

		//reset the global marker reference buffer
		window.markers = [];

		if(this.googleMap) {
			//if we have a reference to the locationMap, set directions display to none to remove it
			this.googleMap.directionsDisplay.setMap(null);
			this.googleMap.mapReference.setZoom(this.reset_level);
			this.googleMap.mapReference.setCenter(this.state.mapCenter);
		}

		this.storeState({
			renderedMarkers: window.markers, //empty array
			renderList: [], //no markers should be rendered
			markerPopupIsVisible: false, //popup is not visible
			selectedMarker: undefined //undefine selected marker
		});
	}

	onCategoryChange(selectedCategory) {
		this.onMarkerPopupClose();
		for (let j = 0; j < window.markers.length; j++) {
			window.markers[j].setMap(null);
		}

		window.markers = [];

		if (this.googleMap) {
			this.googleMap.directionsDisplay.setMap(null);
		}

		let newSelectedCategory = undefined;
		let renderList = [];
		let newDetailsBoxVisible = false;
		if (this.state.selectCategory !== selectedCategory) {
			renderList = this.state.masterList.filter(
				(marker) => (marker.markerGroupId === selectedCategory || marker.markerGroupId === 0)
				);
			if (renderList.length === 0) {
				renderList = this.state.masterList;
			}
			newSelectedCategory = selectedCategory;
			newDetailsBoxVisible = true;
		} else {
			renderList = [];
		}

		this.storeState({
			renderedMarkers: window.markers,
			renderList: renderList,
			markerPopupIsVisible: false,
			selectedMarker: undefined,
			selectCategory: newSelectedCategory,
			detailsBoxVisible: newDetailsBoxVisible,
		});

		this.onRenderMarkers(renderList, this.googleMap.mapReference);
	}

	onMapAerialSwitch() {
		if(this.state.display.buttonText==="Aerial Map"){
			this.storeState({
				display: {
					buttonText: "Interactive Map",
					aerialMap: "active",
					googleMap: "",
					downloadButtonText: "Download Aerial Map",
					downloadURL: this.state.aerialdownloadUrl,
				}
			});
		} else {
			this.storeState({
				display: {
					buttonText: "Aerial Map",
					aerialMap: "",
					googleMap: "active",
					downloadButtonText: "Download Location Map",
					downloadURL: this.state.locationdownloadUrl,
				}
			});
		}
	}

	render() {
		console.log(this.state)
		if(typeof this.state.masterplanOverlay.imageUrl !== 'undefined') {
			return (
				<div id={"locationmap"}>
					<LocationMap
						ref={(googleMap) => {
							if (googleMap !== null) {
								this.googleMap = googleMap;
							}
						}}
						mapId="location-map"
						apiKey={sources.googlemapsapikey}
						messenger={messenger}
						mapConfig={this.state.mapConfig}
						selectedMarker={this.state.selectedMarker}
						selectCategory={this.state.selectCategory}
						markerPopupIsVisible={this.state.markerPopupIsVisible}
						onMarkerPopupClose={this.onMarkerPopupClose.bind(this)}
						markers={this.selectRenderList()}
						renderedMarkers={this.state.renderedMarkers}
						markerGroups={this.state.markerGroups}
						mapDetailsBoxVisible={this.state.detailsBoxVisible}
						onRenderMarkers={this.onRenderMarkers.bind(this)}
						onCategoryChange={this.onCategoryChange.bind(this)}
						onCategoryReset={this.onCategoryReset.bind(this)}
						masterplanOverlay={this.state.masterplanOverlay}
						masterplanOverlayRedirect={sources.landlink}
						display={this.state.display}
						aerialimageUrl={this.state.aerialimageUrl}
						locationdownloadUrl={this.state.locationdownloadUrl}
						mapAerialSwitch={this.onMapAerialSwitch.bind(this)}
					/>
				</div>
			);
		} else {
			return (
				<PageLoading>Location Map</PageLoading>
			)
		}
	}
}

function requestAndRenderDirections(origin, markerData, travelMode, directionService) {
	return new Promise(function (resolve, reject) {
		let destination = new window.google.maps.LatLng(markerData.latitude, markerData.longtitude);
		let request = {
			origin: origin,
			destination: destination,
			travelMode: travelMode
		};

		directionService.route(request, function(response, status) {
			if(status === 'OK') {
				resolve(response);
			} else {
				reject();
			}
		});
	});
}

export default Location;


/** WEBPACK FOOTER **
 ** ./src/modules/location/Location.js
 **/